import axios from "axios";
import {
  Chart,
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  PieController,
  LineController,
  CategoryScale,
  LinearScale,
  TimeScale,
  Legend,
  Tooltip,
  Filler,
} from "chart.js";
import dayjs from "dayjs";
import "dayjs/locale/de.js";
import "chartjs-adapter-dayjs-3";
Chart.register(
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  PieController,
  LineController,
  CategoryScale,
  LinearScale,
  TimeScale,
  Legend,
  Tooltip,
  Filler,
);
const modalClosingEvent = new Event("modal-closing");

function getXScaleUnit(startDate, endDate) {
  if (!endDate) endDate = dayjs().format("YYYY-MM-DD");
  const timedelta = dayjs(endDate).diff(dayjs(startDate), "days");
  if (timedelta > 730) {
    return "year";
  }
  if (timedelta > 150) {
    return "month";
  }
  if (timedelta > 21) {
    return "week";
  }
  return "day";
}

async function initChart(category, id, latest = false) {
  const ctx = document.getElementById(`${category}-${id}`);
  if (!ctx) return null;
  axios
    .get(
      category === "public" ? `/stats/${id}` : `/admin/stats/${category}/${id}`,
    )
    .then(function (response) {
      if ("language" in ctx.dataset) dayjs.locale(ctx.dataset.language);
      ctx.dataset.since = response.data.data.since;
      new Chart(ctx, response.data);
      // populate total field
      let total = document.getElementById(`${category}-${id}-total`);
      if (total) {
        total.innerHTML = response.data.data.total
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      // populate 'as of' field
      let asOf = document.getElementById(`${category}-${id}-asOf`);
      if (asOf) asOf.innerHTML = dayjs(response.data.data.asOf).format("LLL");
      if (!latest) initChartUpdater(category, id, response.data.data.since);
    })
    .catch(function (error) {
      console.error(error);
    });
}

function initChartUpdater(category, id, firstDate) {
  // add event listender for "all" button
  document
    .getElementById(`${category}-${id}-all-button`)
    .addEventListener("click", (e) => updateEvent(e, category, id));
  // build full year buttons
  let fullYearGrid = document.getElementById(`${category}-${id}-fullYear-grid`);
  let year = dayjs(firstDate).format("YYYY");
  while (year <= dayjs().year()) {
    let cell = document.createElement("div");
    cell.classList.add("cell");
    let button = document.createElement("button");
    button.className = "button is-primary is-outlined is-fullwidth";
    button.setAttribute("data-rangecode", year);
    button.innerHTML = year;
    button.addEventListener("click", (e) => updateEvent(e, category, id));
    cell.appendChild(button);
    fullYearGrid.appendChild(cell);
    year++;
  }
  // add event listender for "year" and "month" buttons
  document
    .querySelectorAll(".modal .content .chart-updater")
    .forEach((button) => {
      button.addEventListener("click", (e) =>
        updateEvent(e, button.dataset.category, button.dataset.id),
      );
    });
}

function updateEvent(event, category, id) {
  let startDate;
  let endDate = null;
  let rangeCode = event.target.dataset["rangecode"];
  let modal = document.getElementById(`${category}-${id}-time-modal`);
  modal.classList.remove("is-active");
  modal.dispatchEvent(modalClosingEvent);
  window.dispatchEvent(new Event("modal-closed-" + modal.dataset.target));
  // update active Button
  modal
    .querySelectorAll(".content button:not(.is-outlined)")
    .forEach((button) => {
      button.classList.add("is-outlined");
    });
  event.target.classList.remove("is-outlined");
  if (rangeCode !== "all") {
    if (/^(19|20)\d{2}$/.test(rangeCode)) {
      // handle yearly ranges
      startDate = dayjs(rangeCode)
        .startOf("year")
        .format("YYYY-MM-DD 00:00:00");
      endDate = dayjs(rangeCode).endOf("year").format("YYYY-MM-DD 00:00:00");
    } else {
      // handle year since and month since ranges
      const [rangeType, rangeValue] = rangeCode.split("-");
      startDate = dayjs()
        .subtract(rangeValue, rangeType)
        .format("YYYY-MM-DD 00:00:00");
    }
  }
  let chart = Chart.getChart(`${category}-${id}`);
  chart.options.scales.x.time.unit = getXScaleUnit(
    startDate || chart.data.since,
    endDate,
  );
  chart.options.scales.x.min = startDate;
  chart.options.scales.x.max = endDate;
  chart.update();
}

export { initChart };
